import { gql, useLazyQuery } from "@apollo/client";
import { useCallback } from "react";

export type BookedClassRoom = {
  id: string;
  startedAtUtc: string;
  endedAtUtc: string;
  classRoomTimezone: string;
};

const Get1on1PlanManagementInfoQuery = gql`
  query get1on1PlanManagementInfo($planId: String!) {
    get1on1PlanManagementInfo(planId: $planId) {
      teacherId
      bookedClassRooms {
        id
        startedAtUtc
        endedAtUtc
        classRoomTimezone
      }
    }
  }
`;

export function useGetBookedClassRoomsForPlan() {
  const [executeQuery, { loading, data }] = useLazyQuery<{
    get1on1PlanManagementInfo: {
      teacherId: string | null;
      bookedClassRooms: BookedClassRoom[];
    };
  }>(Get1on1PlanManagementInfoQuery, { fetchPolicy: "network-only" });

  const loadClassRooms = useCallback(
    (planId: string) => {
      executeQuery({ variables: { planId } });
    },
    [executeQuery],
  );

  return {
    loadClassRooms,
    classRooms: data?.get1on1PlanManagementInfo.bookedClassRooms ?? [],
    teacherId: data?.get1on1PlanManagementInfo.teacherId ?? null,
    loading,
  };
}
